import { render, staticRenderFns } from "./War.vue?vue&type=template&id=70914ab8&scoped=true&"
import script from "./War.vue?vue&type=script&lang=js&"
export * from "./War.vue?vue&type=script&lang=js&"
import style0 from "./War.vue?vue&type=style&index=0&id=70914ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70914ab8",
  null
  
)

component.options.__file = "War.vue"
export default component.exports